import { useLineupCollections } from '@/components/user_catalog/collections/useLineupCollections';
import { HomePreviewShelf } from './HomePreviewShelf';
import type { HomePreviewSection } from './homePreviewModel';

interface HomePreviewShelvesProps {
  sections: HomePreviewSection[];
}

/** The feed below the hero — one shelf per home section, in section order. */
export const HomePreviewShelves = ({ sections }: HomePreviewShelvesProps) => {
  const { collectionById } = useLineupCollections(
    sections.map((section) => section.collectionId)
  );

  return (
    <div style={{ paddingBottom: 8 }}>
      {sections.map(({ collectionId, displayMode }, i) => (
        // Ids can repeat transiently while a row is being re-picked.
        <HomePreviewShelf
          key={`${collectionId}-${i}`}
          collectionId={collectionId}
          name={
            collectionById.get(collectionId)?.header ??
            collectionById.get(collectionId)?.name
          }
          kind={collectionById.get(collectionId)?.collection_kind}
          displayMode={displayMode}
          collection={collectionById.get(collectionId)}
        />
      ))}
    </div>
  );
};
